var cilAsterisk = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='286.903 256 416 177.877 416 141.115 415.717 140.646 272 227.617 272 72 240 72 240 227.617 96.283 140.646 96 141.115 96 177.877 225.097 256 96 334.123 96 370.885 96.283 371.354 240 284.383 240 440 272 440 272 284.383 415.717 371.354 416 370.885 416 334.123 286.903 256' class='ci-primary'/>"];

export { cilAsterisk };

